import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoidPaymentComponent } from './void-payment.component';

import { VoidPaymentRoutingModule } from './void-payment-routing-routing.module';
import { VoidPaymentListModule } from './void-payment-list/void-payment-list.module';



@NgModule({
  declarations: [VoidPaymentComponent],
  imports: [
    CommonModule,
    VoidPaymentListModule,
    VoidPaymentRoutingModule
  ],
  exports: [VoidPaymentComponent]
})
export class VoidPaymentModule { }
